import { useMainContext } from '../../hooks/useMainContext';
export const Closet = () => {
    const { closetManager } = useMainContext();

    return (
        <canvas
            className="closet-canvas"
            style={{ position: 'absolute' }}
            ref={(ref) => ref && closetManager.setClosetCanvas(ref)}
        />
    );
};
